import { Action } from '@ngrx/store';

export enum AssetsActionTypes {
  INIT_PROPERTY_WALL = '[Cyclops Assets] Init Property Wall',
  INIT_MANAGE_PROPERY = '[Cyclops Assets] Init Manage Property',
  INIT_MANAGE_PROPERY_ASSET = '[Cyclops Assets] Init Manage Property Asset',
  INIT_SCANNING_ASSET = '[Cyclops Assets] Init Scanning Asset',
  LOAD_PROPERTY_DATA = '[Cyclops Assets] Load Property Data',
  LOAD_PROPERTY_DATA_SUCCESS = '[Cyclops Assets] Load Property Data Success',
  LOAD_PROPERTY_DATA_FAILURE = '[Cyclops Assets] Load Property Data Failure',
  ADD_NEW_PROPERTY = '[Cyclops Assets] Add New Property',
  ADD_NEW_PROPERTY_SUCCESS = '[Cyclops Assets] Add New Property Success',
  ADD_NEW_PROPERTY_FAILURE = '[Cyclops Assets] Add New Property Failure',
  REMOVE_PROPERTY = '[Cyclops Assets] Remove Property',
  REMOVE_PROPERTY_SUCCESS = '[Cyclops Assets] Remove Property Success',
  REMOVE_PROPERTY_FAILURE = '[Cyclops Assets] Remove Property Failure',
  EDIT_PROPERTY = '[Cyclops Assets] Edit Property',
  EDIT_PROPERTY_SUCCESS = '[Cyclops Assets] Edit Property Success',
  EDIT_PROPERTY_FAILURE = '[Cyclops Assets] Edit Property Failure',
  ADD_NEW_ASSET = '[Cyclops Assets] Add New Asset',
  ADD_NEW_ASSET_SUCCESS = '[Cyclops Assets] Add New Asset Success',
  ADD_NEW_ASSET_FAILURE = '[Cyclops Assets] Add New Asset Failure',
  REMOVE_ASSET = '[Cyclops Assets] Remove Asset',
  REMOVE_ASSET_SUCCESS = '[Cyclops Assets] Remove Asset Success',
  REMOVE_ASSET_FAILURE = '[Cyclops Assets] Remove Asset Failure',
  EDIT_ASSET = '[Cyclops Assets] Edit Asset',
  EDIT_ASSET_SUCCESS = '[Cyclops Assets] Edit Asset Success',
  EDIT_ASSET_FAILURE = '[Cyclops Assets] Edit Asset Failure',
  SCAN_CAMERA = '[Cyclops Assets] Scan Camera',
  SCAN_CAMERA_SUCCESS = '[Cyclops Assets] Scan Camera Success',
  SCAN_CAMERA_FAILURE = '[Cyclops Assets] Scan Camera Failure',
  BACK_TO_PROPERTY_WALL = '[Cyclops Assets] Back To Property Wall',
  RESET_STATE = '[Cyclops Assets] Reset State',
}
export class ResetState implements Action {
  readonly type = AssetsActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitPropertyWall implements Action {
  readonly type = AssetsActionTypes.INIT_PROPERTY_WALL;
  constructor(public payload: any) {}
}
export class InitManageProperty implements Action {
  readonly type = AssetsActionTypes.INIT_MANAGE_PROPERY;
  constructor(public payload: any) {}
}
export class InitManagePropertyAsset implements Action {
  readonly type = AssetsActionTypes.INIT_MANAGE_PROPERY_ASSET;
  constructor(public payload: any) {}
}
export class InitScanAsset implements Action {
  readonly type = AssetsActionTypes.INIT_SCANNING_ASSET;
  constructor(public payload: any) {}
}
export class LoadPropertyData implements Action {
  readonly type = AssetsActionTypes.LOAD_PROPERTY_DATA;
  constructor(public payload: any) {}
}
export class LoadPropertyDataSuccess implements Action {
  readonly type = AssetsActionTypes.LOAD_PROPERTY_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class LoadPropertyDataFailure implements Action {
  readonly type = AssetsActionTypes.LOAD_PROPERTY_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class AddNewProperty implements Action {
  readonly type = AssetsActionTypes.ADD_NEW_PROPERTY;
  constructor(public payload: any) {}
}
export class AddNewPropertySuccess implements Action {
  readonly type = AssetsActionTypes.ADD_NEW_PROPERTY_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewPropertyFailure implements Action {
  readonly type = AssetsActionTypes.ADD_NEW_PROPERTY_FAILURE;
  constructor(public payload: any) {}
}
export class RemoveProperty implements Action {
  readonly type = AssetsActionTypes.REMOVE_PROPERTY;
  constructor(public payload: any) {}
}
export class RemovePropertySuccess implements Action {
  readonly type = AssetsActionTypes.REMOVE_PROPERTY_SUCCESS;
  constructor(public payload: any) {}
}
export class RemovePropertyFailure implements Action {
  readonly type = AssetsActionTypes.REMOVE_PROPERTY_FAILURE;
  constructor(public payload: any) {}
}
export class AddNewAsset implements Action {
  readonly type = AssetsActionTypes.ADD_NEW_ASSET;
  constructor(public payload: any) {}
}
export class AddNewAssetSuccess implements Action {
  readonly type = AssetsActionTypes.ADD_NEW_ASSET_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewAssetFailure implements Action {
  readonly type = AssetsActionTypes.ADD_NEW_ASSET_FAILURE;
  constructor(public payload: any) {}
}
export class RemoveAsset implements Action {
  readonly type = AssetsActionTypes.REMOVE_ASSET;
  constructor(public payload: any) {}
}
export class RemoveAssetSuccess implements Action {
  readonly type = AssetsActionTypes.REMOVE_ASSET_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveAssetFailure implements Action {
  readonly type = AssetsActionTypes.REMOVE_PROPERTY_FAILURE;
  constructor(public payload: any) {}
}
export class ScanCamera implements Action {
  readonly type = AssetsActionTypes.SCAN_CAMERA;
  constructor(public payload: any) {}
}
export class ScanCameraSuccess implements Action {
  readonly type = AssetsActionTypes.SCAN_CAMERA_SUCCESS;
  constructor(public payload: any) {}
}
export class ScanCameraFailure implements Action {
  readonly type = AssetsActionTypes.SCAN_CAMERA_FAILURE;
  constructor(public payload: any) {}
}
export class EditAsset implements Action {
  readonly type = AssetsActionTypes.EDIT_ASSET;
  constructor(public payload: any) {}
}
export class EditAssetSuccess implements Action {
  readonly type = AssetsActionTypes.EDIT_ASSET_SUCCESS;
  constructor(public payload: any) {}
}
export class EditAssetFailure implements Action {
  readonly type = AssetsActionTypes.EDIT_ASSET_FAILURE;
  constructor(public payload: any) {}
}
export class EditProperty implements Action {
  readonly type = AssetsActionTypes.EDIT_PROPERTY;
  constructor(public payload: any) {}
}
export class EditPropertySuccess implements Action {
  readonly type = AssetsActionTypes.EDIT_PROPERTY_SUCCESS;
  constructor(public payload: any) {}
}
export class EditPropertyFailure implements Action {
  readonly type = AssetsActionTypes.EDIT_PROPERTY_FAILURE;
  constructor(public payload: any) {}
}
export class BackToPropertyWall implements Action {
  readonly type = AssetsActionTypes.BACK_TO_PROPERTY_WALL;
  constructor(public payload: any) {}
}
export type CyclopsAssetsActionUnion =
  | ResetState
  | InitPropertyWall
  | LoadPropertyData
  | LoadPropertyDataSuccess
  | LoadPropertyDataFailure
  | InitManageProperty
  | InitManagePropertyAsset
  | InitScanAsset
  | AddNewProperty
  | AddNewPropertySuccess
  | AddNewPropertyFailure
  | RemoveProperty
  | RemovePropertySuccess
  | RemovePropertyFailure
  | AddNewAsset
  | AddNewAssetSuccess
  | AddNewAssetFailure
  | RemoveAsset
  | RemoveAssetSuccess
  | RemoveAssetFailure
  | ScanCamera
  | ScanCameraSuccess
  | ScanCameraFailure
  | EditProperty
  | EditPropertySuccess
  | EditPropertyFailure
  | EditAsset
  | EditAssetSuccess
  | EditAssetFailure
  | BackToPropertyWall;
